export const identifyHubspot = (email: string, extraFields?: Record<string, unknown>) => {
    if (typeof window === 'undefined') return;
    const _hsq = (window._hsq = window._hsq || []);
    _hsq.push(['identify', extraFields ? { ...extraFields, email: email } : { email: email }]);
};
